module.exports = __webpack_public_path__ + "static/media/coronavirus.6dfdb92f.svg";